import { useEffect, useRef, useState } from "react";
import { Icon } from "react-icons-kit";
import { bell } from "react-icons-kit/feather/bell";
import style from "./Notifications.module.css"
import { Link, useNavigate } from "react-router-dom";
import { balanceScale } from "react-icons-kit/fa/balanceScale";
import { inbox } from "react-icons-kit/fa/inbox";
import { useSelector } from "react-redux";
import { users } from "react-icons-kit/fa/users";
function Notification({ notifications={} }) {
  const [open, setOpen] = useState(false);

  const User=useSelector(state=>state.User)
  const navigate=useNavigate()
    
  const popupRef=useRef()
  useEffect(()=>{
    
    const handleOutsideClick=(e)=>{
      if(popupRef.current && !popupRef.current.contains(e.target)){
        setOpen(false)
      }
    }
    document.addEventListener("mousedown",handleOutsideClick)
    return ()=>{
      document.removeEventListener("mousedown",handleOutsideClick)
    }
  },[])
  return (
    <div style={{ position: "relative" }}>
      
      <Icon
        icon={bell}
        size={22}
        onClick={() => setOpen(!open)}
        style={{cursor:"pointer"}}
      />

      {notifications[0]?.pending_appeals+notifications[0]?.pending_requests > 0? (
        <span
          style={{
            position: "absolute",
            top: "-5px",
            right: "-5px",
            background: "red",
            color: "white",
            borderRadius: "50%",
            padding: "2px 6px",
            fontSize: "11px",
          }}
        >
          {notifications[0]?.pending_appeals+notifications[0]?.pending_requests>5?"5+":notifications[0]?.pending_appeals+notifications[0]?.pending_requests || 0}
        </span>
      ):null}

      {open && (
        <div

        ref={popupRef}
          style={{
            position: "absolute",
            top: "30px",
            right: "0",
            width: "300px",
            background: "#fff",
            border: "1px solid #ddd",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            zIndex: 1000,
          }}
        >
          {notifications[0]?.pending_appeals+notifications[0]?.pending_requests === 0 ? (
            <div style={{ padding: "10px" }}>No notifications</div>
          ) : (
            notifications.map((n, i) => (
                <div key={i} className={style.notificationItem}>
                <div className={style.notificationTitle}>Notification Hub</div>
              
              {n.pending_appeals>0 &&  <div key={i} className={style.card} onClick={()=>{navigate(User.user_type=="Issuer"?"dashboard/DocAppeals":"/dashboard/emp/requests");setOpen(false)}}>
                  <div className={style.cardTitle}>
                  <Icon icon={balanceScale} size={18}/>  You have {n.pending_appeals} pending appeals
                  </div>
                  </div>}


                {n.pending_requests>0 &&  <div className={style.card} onClick={()=>{navigate(User.user_type=="Issuer"?"/dashboard/verification_requests":"/dashboard/emp/requests", {state:"pending_requests"});setOpen(false)}}>
                  <div className={style.cardTitle}>
                   <Icon icon={inbox} size={18}/> You have {n.pending_requests} pending requests
                  </div>
                  
              </div>}
            {/* {n.new_issuers_onboarded>0 &&User.user_type=="Verifier"&&  <div className={style.card} onClick={()=>{navigate("/dashboard/Issuers");setOpen(false)}}>
                  <div className={style.cardTitle}>
                   <Icon icon={users} size={18}/> {n.new_issuers_onboarded} new {`${n.new_issuers_onboarded>1?"issuers":"issuer"}`} onboarded
                  </div>
                  
              </div>} */}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default Notification;